<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{$t('nav.home')}}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{$t('label.new_establishment')}}
        </li>
      </ol>
    </nav>
    <form-establishment :id="null" @sendForm="receiveForm" />
  </div>
</template>

<script>
import FormEstablishment from "../components/forms/FormEstablishment.vue";
import { setEstablishment } from "../services/establishment";

export default {
  components: {
    FormEstablishment,
  },
  data() {
    return {
      form: {
        esta_id: null,
        esta_internal_name: "",
        esta_name: "",
        esta_nice_name: "",
        parent_id: null,
        esta_address: "",
        esta_city: "",
        esta_postalcode: "",
        esta_country: "",
        esta_email: "",
        esta_phone: "",
        esta_is_internal: false,
        esta_is_enable: false,
        tags: [],
      },
      delay: 6000
    };
  },
  

  methods: {
    async receiveForm(formEstablishment) {
      setEstablishment(JSON.parse(formEstablishment))
        .then(() => {
          console.log("succes");
          this.showToast(
            "success",
            this.$t("msg.text.success_add_esta"),
            this.$t("msg.title.etablissement"),
            this.delay,
            null,
            null, 
            'b-toaster-bottom-center'
          );

          // On retourne à la page précédente après le delai d'affichage du message
          setTimeout( () => this.$router.go(-1), this.delay);
        })
        .catch((error) => {
          console.error(error);
          this.showToast(
            "error",
            this.$t("msg.text.error_add_esta"),
            this.$t("msg.title.etablissement")
          );
        });
    },
  },
};
</script>
